export function pleitoVeiculoInRequest(params = {}) {
  return {
    type: '@pleitoveiculo/PLEITOVEICULO_IN_REQUEST',
    payload: { params },
  };
}

export function findPleitoVeiculo(idpleito) {
  return {
    type: '@pleitoveiculo/FIND_PLEITOVEICULO',
    payload: { idpleito },
  };
}

export function failedRequest() {
  return {
    type: '@pleitoveiculo/FAILED_REQUEST',
  };
}

export function deletePleitoVeiculo(idpleito, params) {
  return {
    type: '@pleitoveiculo/DELETE_PLEITOVEICULO',
    payload: { idpleito, params },
  };
}

export function updatePleitoVeiculo(pleito, params) {
  return {
    type: '@pleitoveiculo/UPDATE_PLEITOVEICULO',
    payload: { pleito, params },
  };
}

export function storePleitoVeiculo(pleito, params) {
  return {
    type: '@pleitoveiculo/STORE_PLEITOVEICULO',
    payload: { pleito, params },
  };
}

export function successInRequest(
  pleitoveiculos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@pleitoveiculo/SUCCESS_IN_REQUEST',
    payload: { pleitoveiculos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(pleitoveiculos) {
  return {
    type: '@pleitoveiculo/SUCCESS_REQUEST',
    payload: { pleitoveiculos },
  };
}

export function successRemove(params) {
  return {
    type: '@pleitoveiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@pleitoveiculo/RECORD_FILTERING',
    payload: { params },
  };
}
